<template>
  <div>
    <v-data-table
      :items="items"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"

      :single-expand="true"
      :expanded.sync="expanded"

      class="elevation-1"
      v-bind="tableAttrs"
      v-on="$listeners"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title v-if="frontinusTitle">{{ frontinusTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-if="frontinusShowSearch"
            v-model.trim="search"
            append-icon="mdi-magnify"
            label="Hľadaj"
            single-line
            hide-details
          ></v-text-field>
          <slot name="customFilters"></slot>
          <v-spacer></v-spacer>
          <v-btn v-if="frontinusShowNewButton" @click="$emit('newItem')" color="primary">{{ frontinusNewButtonText }}</v-btn>
        </v-toolbar>
      </template>

      <template v-if="frontinusActionColumn" v-slot:item.action="{ item }">
        <v-icon v-if="frontinusActionColumn.print" class="mr-2" @click.stop="$emit('printItem', item)">mdi-printer</v-icon>
        <v-icon v-if="frontinusActionColumn.download" class="mr-2" @click.stop="$emit('downloadItem', item)">mdi-download</v-icon>
        <v-icon v-if="frontinusActionColumn.edit" class="mr-2" @click.stop="$emit('editItem', item)">mdi-pencil</v-icon>
        <v-icon v-if="frontinusActionColumn.delete" class="mr-2" @click.stop="deleteItem(item)">mdi-delete</v-icon>
        <v-icon v-if="frontinusActionColumn.copy" class="mr-2" @click.stop="$emit('copyItem', item)">mdi-content-copy</v-icon>
        <slot name="customActions" :item="item"></slot>
      </template>

      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
          <slot :name="slot" v-bind="scope"/>
      </template>
    </v-data-table>

    <v-dialog v-model="deleteItemDialog" max-width="300px">
      <v-card>
        <v-card-title class="text-center">Naozaj vymazať položku?</v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="closeDeleteItemDialog(true)">Áno</v-btn>
          <v-btn text color="primary" @click="closeDeleteItemDialog(false)">Nie</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config/app.config'

export default Vue.extend({
  props: {
    frontinusItemsLoader: {
      type: Function,
      required: true
    },
    frontinusActionColumn: {
      type: Object,
      default: () => {
        return {
          print: true,
          download: true,
          edit: true,
          delete: true
        }
      }
    },
    frontinusTitle: {
      type: String,
      default: null
    },
    frontinusShowSearch: {
      type: Boolean,
      default: true
    },
    frontinusShowNewButton: {
      type: Boolean,
      default: true
    },
    frontinusNewButtonText: {
      type: String,
      default: 'Pridať'
    }
  },

  data () {
    return {
      totalItems: 0,
      items: [],
      loading: true,
      search: '',
      options: {
        groupBy: [],
        groupDesc: [],
        itemsPerPage: AppConfig.dataTables.itemsPerPage,
        multiSort: false,
        mustSort: false,
        page: 1,
        sortBy: [],
        sortDesc: []
      },
      expanded: [],
      tableAttrs: {},
      deleteItemDialog: false,
      itemToDelete: null
    }
  },

  computed: {
    hasSearching () {
      return ((this.search.length === 0) || (this.search.length >= 3))
    }
  },

  watch: {
    options: {
      handler () {
        this.loadList()
      },
      deep: true
    },
    search: {
      handler () {
        if (this.hasSearching) {
          this.loadList()
        }
      }
    }
  },

  methods: {
    reload () {
      this.loadList()
    },
    loadList () {
      this.loading = true
      this.frontinusItemsLoader(this.apiParams(this.options))
        .then(res => {
          this.items = res.data
          this.totalItems = res.meta.total
          // this.totalItems = res.pagination.totalItems
        })
        .finally(() => {
          this.loading = false
        })
    },
    apiParams (options) {
      const params = {
        maxItems: this.options.itemsPerPage,
        page: this.options.page
      }

      const sorting = this.apiSorting(options)
      if (sorting) {
        params.orderBy = sorting.orderBy
        params.order = sorting.order
      }

      if (this.hasSearching && this.search) {
        params.search = this.search
      }

      return params
    },
    apiSorting (options) {
      let sorting = {}
      options.sortBy.forEach((orderBy, i) => {
        sorting = {
          orderBy,
          order: options.sortDesc[i] ? 'DESC' : 'ASC'
        }
      })
      return sorting
    },
    deleteItem (item) {
      this.itemToDelete = item
      this.deleteItemDialog = true
    },
    closeDeleteItemDialog (isConfirmed) {
      if (isConfirmed) {
        this.$emit('deleteItem', this.itemToDelete)
      }
      this.deleteItemDialog = false
    }
  },

  mounted () {
    const attrs = this.$attrs
    this.tableAttrs = attrs

    this.loadList()
  }
})
</script>
